import { Checkbox, Space, Divider, Row, Button } from 'antd';
import { useCallback, useContext, useMemo } from 'react';

import { VISITED, NOVISIT, WAITING, CONFIRMED } from '@app/constants';
import { useWindowSize } from '@app/hooks';
import {
  CHF_STATUSES,
  CHF_VISITS_FILTER,
} from '@app/pages/Clients/ClientsList/constants/filterKeysAndIds';
import { hideFilterBlock } from '@app/pages/Clients/ClientsList/utils';
import { ClientFiltersContext } from '@app/providers';
import type { NClients } from '@app/types';

type TCheckboxValueType = string | number | boolean;

export const ClientsRecordStatuses = ({
  filterGroupIndex,
}: {
  filterGroupIndex: number;
}) => {
  const {
    filters,
    setUpServerDataChunk,
    handleDisabling,
    onChangeFiltersHandler,
  } = useContext(ClientFiltersContext);
  const { innerWidth } = useWindowSize();

  const currentValue = useMemo(
    () =>
      (filters.VisitsFilter?.[filterGroupIndex]?.Values?.[0]
        ?.Statuses as TCheckboxValueType[]) || null,
    [filters, filterGroupIndex]
  );

  const handleRecordStatusesChange = useCallback(
    (checkedValues: NClients.Status[]) => {
      onChangeFiltersHandler(
        'VisitsFilter',
        filterGroupIndex,
        'Statuses',
        checkedValues
      );
    },
    [filterGroupIndex, onChangeFiltersHandler]
  );

  return (
    <div onClick={(e: MouseEvent | React.MouseEvent) => e.stopPropagation()}>
      <Checkbox.Group
        value={currentValue as NClients.Status[]}
        onChange={handleRecordStatusesChange}
      >
        <Space direction="vertical">
          <Checkbox value={VISITED}>Клиент пришел</Checkbox>
          <Checkbox value={NOVISIT}>Клиент не пришел</Checkbox>
          <Checkbox value={WAITING}>Ожидание клиента</Checkbox>
          <Checkbox value={CONFIRMED}>Клиент подтвердил</Checkbox>
        </Space>
      </Checkbox.Group>
      <Divider style={{ marginTop: '8px', marginBottom: '12px' }} />
      <Row justify="end">
        <Button
          type="primary"
          size="small"
          disabled={handleDisabling(
            CHF_VISITS_FILTER,
            CHF_STATUSES,
            false,
            '',
            filterGroupIndex
          )}
          onClick={() => {
            setUpServerDataChunk(
              CHF_VISITS_FILTER,
              CHF_STATUSES,
              false,
              '',
              filterGroupIndex
            );

            hideFilterBlock(
              '.clients-record-statuses-label',
              innerWidth,
              filterGroupIndex
            );
          }}
        >
          Выбрать
        </Button>
      </Row>
    </div>
  );
};
